AddMetaBusinessManagerListController.$inject = ['$scope', 'TopToolbarFactory', '$stateParams'];
export function AddMetaBusinessManagerListController($scope, TopToolbarFactory, $stateParams) {
  $scope.code = $stateParams.code;
  
  init();

  function init() {
    TopToolbarFactory.setTitleTranslation('business-manager/select', $scope);
  }
}